import Cookies from 'js-cookie'


export function getToken() {
  return Cookies.get(process.env.VUE_APP_TOKEN_NAME)
}

export function setToken(token) {
  return Cookies.set(process.env.VUE_APP_TOKEN_NAME, token)
}

export function removeToken() {
  return Cookies.remove(process.env.VUE_APP_TOKEN_NAME)
}
